import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { scrollToTop } from '../../utils/scrollTo'
import NavButton from './navButton.component'
import SortableTable from '../../utils/sortableTable'
import WorkShiftUserRowContainer from '../../containers/openforwork/workShiftUserRow.container'
import TimeReportFormContainer from '../../containers/openforwork/timeReportForm.container'
import './GlobalCssDateCalendar.css'
import JournalRowContainer from '../../containers/openforwork/journalRow.container'
import SnackbarComponent from '../../utils/employer/snackbarComponent.utils'
import ExpandablePanel from '../../utils/expandablePanel'
import Button from '@material-ui/core/Button'
import mobileView from '../../utils/mobile.utils'
import ModalComponent from '../layout/modal.component'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core'
import ReactPaginate from 'react-paginate'
import {
  searchWorkshifts,
  WorkshiftFilters
} from '../../utils/openForWork.utils'
import { groupWorkshiftByCompany } from '../../containers/openforwork/workshiftNormalUser.container'
import { useNavigationPrompt } from '../../NavigationPromptProvider'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

class WorkshiftNormalUserComponent extends React.Component {
  componentDidMount() {
    this.props.getEmployerWorkshift()
    this.props.getWorkshiftUser()
    this.props.getBillableHourUser()
    this.props.getJournal()
    scrollToTop()
  }
  render() {
    return <WorkshiftNormalUser {...this.props} />
  }
}

const styles = (theme) => ({
  select: {
    lineHeight: '1',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    width: '300px',
    border: '1px solid gray',
    backgroundColor: '#FFFFFF'
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '13px'
  },
  checkbox: {
    fontSize: '14px',
    margin: '0px',
    color: '#808080',
    fontWeight: 500
  },
  searchField: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  button: {
    margin: 15
  },
  searchField: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    justifyContent: 'space-between'
  },
  filterFields: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 8px 30px',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 8px 30px',
      alignItems: 'stretch'
    }
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  },
  clearFieldButton: {
    position: 'absolute',
    marginLeft: '-36px',
    marginRight: '4px',
    marginTop: '50px',
    alignSelf: 'flex-end',
    height: '32px',
    width: '32px'
  },
  clearIcon: {
    height: '18px',
    width: '18px'
  }
})

const defaultValues = {
  company_name: '',
  task_description: '',
  workshift_date: null,
  status: '',
  pinned: false,
  pageSize: 10
}

const statusOptions = [
  { value: '', label: '' },
  { value: 0, label: 'ws_status.0' },
  { value: 1, label: 'ws_status.1' },
  { value: 2, label: 'ws_status.2' },
  { value: 3, label: 'ws_status.3' },
  { value: 6, label: 'ws_status.6' }
]

const WorkshiftNormalUser = ({
  classes,
  workShiftUserRowData,
  workshift_journal,
  showSnackbar,
  showFailedSnackbar,
  showSnackbar_update_workshift,
  showFailedSnackbar_update_workshift,
  closeUserWorkshiftSnackbar,
  journalAddSnackbar,
  journalAddFailedSnackbar,
  isEditJournal,
  updateJournalSnackbar,
  updateJournalFailSnackbar,
  saveDraftInvoiceSuccess,
  saveDraftInvoiceFailed,
  updateUserWorkshift
}) => {
  const { confirmAction } = useNavigationPrompt()
  // State variables for modal control
  const [open, setOpen] = React.useState(false)
  const [selectedContent, setSelectedContent] = React.useState(null)
  const [selectedMaxWidth, setSelectedMaxWidth] = React.useState('md')
  const [isSearchEmployer, setIsSearchEmployer] = React.useState(false)
  const [selectedCheckbox, setSelectedCheckbox] = React.useState([])
  const [selectedAllCheckbox, setSelectedAllCheckbox] = React.useState(false)
  const [showAcceptWarn, setShowAcceptWarn] = React.useState(false)

  // Search workshift
  const [isSearchWorkshift, setIsSearchWorkshift] = React.useState(false)
  const [searchWorkshiftValues, setSearchWorkshiftValues] =
    React.useState(defaultValues)

  const [page, setPage] = React.useState(0)

  const filteredWorkshiftRows = searchWorkshifts(
    workShiftUserRowData,
    searchWorkshiftValues
  ).sort((a, b) => new Date(b.created_date) - new Date(a.created_date))

  const acceptableWorkshifts = filteredWorkshiftRows.filter(
    (el) => el.workshift_status_entrepreneur === 0
  )
  const groupedWorkshiftRows = groupWorkshiftByCompany(filteredWorkshiftRows)

  // Function to open modal with specific content and width
  const handleOpenForm = (component, width = 'md') => {
    setSelectedContent(component)
    setSelectedMaxWidth(width)
    setOpen(true)
  }
  const handleClose = (event) => {
    if (event) {
      event.stopPropagation()
    }
    confirmAction('', () => {
      setOpen(false)
      setSelectedContent(null)
      setSelectedMaxWidth('md')
    })
  }
  // const [openRequestEditDialog, setOpenRequestEditDialog] =
  //   React.useState(false)
  React.useEffect(() => {
    if (
      journalAddSnackbar ||
      journalAddFailedSnackbar ||
      updateJournalSnackbar ||
      updateJournalFailSnackbar
    ) {
      setOpen(false)
    }
  }, [
    journalAddSnackbar,
    journalAddFailedSnackbar,
    updateJournalSnackbar,
    updateJournalFailSnackbar
  ])

  function handleSelectCheckbox(
    isSelected,
    workshift_id,
    workshift_itemid,
    offershift_to,
    workshift_status_entrepreneur
  ) {
    if (!isSelected) {
      setSelectedCheckbox((old) => [
        ...old,
        {
          workshift_id: workshift_id,
          workshift_itemid: workshift_itemid,
          offershift_to: offershift_to,
          workshift_status_entrepreneur: workshift_status_entrepreneur
        }
      ])
    } else {
      setSelectedCheckbox((old) =>
        old.filter((id) => id.workshift_itemid !== workshift_itemid)
      )
    }
  }
  function handleSelectAllCheckbox(e) {
    setSelectedAllCheckbox(!selectedAllCheckbox)
    setSelectedCheckbox(
      filteredWorkshiftRows.filter(
        (el) => el.workshift_status_entrepreneur === 0
      )
    )
    if (!e.target.checked) {
      setSelectedCheckbox([])
    }
  }

  // Clear all shifts check box
  React.useEffect(() => {
    if (
      selectedCheckbox.length !==
      filteredWorkshiftRows.filter(
        (el) => el.workshift_status_entrepreneur === 0
      ).length
    ) {
      setSelectedAllCheckbox(false)
    }
  }, [selectedCheckbox, filteredWorkshiftRows])

  return (
    <Translation>
      {(t) => {
        return (
          // <div className="container-big">
          <div className="container">
            <div className="row">
              <div className="dashboard-content-header">
                <h1></h1>
              </div>
            </div>
            <NavButton t={t} type="openforwork" />
            <div style={{ paddingBottom: '10px' }} className="pull-right">
              <Button
                variant="contained"
                style={{ height: '90%', alignItems: 'center' }}
                onClick={() => {
                  handleOpenForm(
                    <TimeReportFormComponent
                      isEditJournal={isEditJournal}
                      t={t}
                    />,
                    '1440px'
                  )
                }}
              >
                {t('workshift.h1c')}
              </Button>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <ExpandablePanel
                    title={t('workshift.h1a')}
                    renderBody={() => (
                      <div className={classes.root}>
                        <WorkshiftFilters
                          t={t}
                          filters={searchWorkshiftValues}
                          onChange={setSearchWorkshiftValues}
                          classes={classes}
                          statusOptions={statusOptions}
                          resetSelectedPage={() => setPage(0)}
                        />
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                className={classes.tableHead}
                                colSpan={2}
                              >
                                {t('workshift.col2')}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {workShiftUserRow(
                              t,
                              classes,
                              groupedWorkshiftRows,
                              page,
                              searchWorkshiftValues.pageSize,
                              selectedCheckbox,
                              handleSelectCheckbox,
                              selectedAllCheckbox
                            )}
                          </TableBody>
                        </Table>
                        <Divider />
                        <div className="panel-body">
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px'
                            }}
                          >
                            <div>
                              <Checkbox
                                icon={
                                  <CheckBoxOutlineBlankIcon fontSize="large" />
                                }
                                checkedIcon={
                                  <CheckBoxIcon
                                    fontSize="large"
                                    style={{ fill: '#F67131' }}
                                  />
                                }
                                onChange={(e) => {
                                  handleSelectAllCheckbox(e)
                                }}
                                checked={selectedAllCheckbox}
                                disabled={acceptableWorkshifts.length === 0}
                              />
                              {t('workshift.checkbox')}
                            </div>
                            <Button
                              variant="contained"
                              onClick={() => {
                                if (selectedCheckbox.length > 0) {
                                  setShowAcceptWarn(true)
                                }
                              }}
                              disabled={selectedCheckbox.length === 0}
                            >
                              {t('workshift.checkboxButton')}
                            </Button>
                            <div></div>
                          </div>

                          {groupedWorkshiftRows.length > 0 ? (
                            <ReactPaginate
                              previousLabel={
                                <i className="fa fa-chevron-left" />
                              }
                              nextLabel={<i className="fa fa-chevron-right" />}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={
                                !!groupedWorkshiftRows
                                  ? Math.ceil(
                                      groupedWorkshiftRows.length /
                                        searchWorkshiftValues.pageSize
                                    )
                                  : 0
                              }
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={(event) => {
                                setPage(event.selected)
                              }}
                              containerClassName={'pagination'}
                              subContainerClassName={'pages pagination'}
                              activeClassName={'active'}
                              forcePage={page}
                            />
                          ) : (
                            <div style={{ padding: '20px' }}></div>
                          )}
                        </div>
                      </div>
                    )}
                    defaultExpanded={true}
                    pageLocation="open_for_work_workshifts"
                    isSearchEmployer={isSearchEmployer}
                    setIsSearchEmployer={setIsSearchEmployer}
                    isSearchWorkshift={isSearchWorkshift}
                    setIsSearchWorkshift={setIsSearchWorkshift}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <ExpandablePanel
                    title={t('ws_journal.h1')}
                    renderBody={() => (
                      <SortableTable
                        data={workshift_journal}
                        createRowComponent={journalRow}
                        headerCells={journal_cells}
                        enableFilters={true}
                      />
                    )}
                    defaultExpanded={false}
                    isAddExtraPaddingEnd={true}
                    paddingEnd={50}
                  />
                </div>
              </div>
            </div>
            <ModalComponent
              open={open}
              onClose={handleClose}
              content={selectedContent}
              maxWidth={selectedMaxWidth}
            />
            <Dialog
              open={showAcceptWarn}
              onClose={() => {
                setShowAcceptWarn(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('workshift.dialogTitle1a')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <span style={{ fontSize: '14px' }}>
                    {t('workshift.dialogContent1a')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowAcceptWarn(false)
                    }}
                  >
                    {t('workshift.btn4')}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      updateUserWorkshift(selectedCheckbox, 0) // Accept workshift
                      setShowAcceptWarn(false)
                      setSelectedCheckbox([])
                    }}
                  >
                    {t('workshift.btn3')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <SnackbarComponent
              open={showSnackbar_update_workshift}
              message={t('workshift.msg1')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            <SnackbarComponent
              open={showFailedSnackbar_update_workshift}
              message={t('workshift.msg2')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            <SnackbarComponent
              open={showSnackbar}
              message={t('workshift.msg3')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            <SnackbarComponent
              open={showFailedSnackbar}
              message={t('workshift.msg4')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            {/*Add journal snack bar*/}
            <SnackbarComponent
              open={journalAddSnackbar}
              message={t('ws_journal.msg1')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            <SnackbarComponent
              open={journalAddFailedSnackbar}
              message={t('ws_journal.msg2')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            {/*Update journal snack bar*/}
            <SnackbarComponent
              open={updateJournalSnackbar}
              message={t('ws_journal.msg3')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            <SnackbarComponent
              open={updateJournalFailSnackbar}
              message={t('ws_journal.msg4')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            {/*Save draft invoice snack bar*/}
            <SnackbarComponent
              open={saveDraftInvoiceSuccess}
              message={t('workshift.msg5')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
            <SnackbarComponent
              open={saveDraftInvoiceFailed}
              message={t('workshift.msg6')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeUserWorkshiftSnackbar}
            />
          </div>
        )
      }}
    </Translation>
  )
}

export const TimeReportFormComponent = () => {
  return (
    <div>
      <div id="time-report-form">
        <TimeReportFormContainer />
      </div>
    </div>
  )
}

const workShiftUserRow = (
  t,
  classes,
  workShiftUserRowData,
  selected,
  pageSize,
  selectedCheckbox,
  handleSelectCheckbox,
  selectedAllCheckbox
) => {
  return workShiftUserRowData
    .slice(selected * pageSize, selected * pageSize + pageSize)
    .map((el, index) => (
      <WorkShiftUserRowContainer
        index={index}
        key={index}
        data={el}
        employer_name={el?.company_name}
        selectedCheckbox={selectedCheckbox}
        handleSelectCheckbox={handleSelectCheckbox}
        selectedAllCheckbox={selectedAllCheckbox}
      />
    ))
}

const journal_cells = [
  {
    id: 'invoice_id',
    label: 'ws_journal.cell1',
    isSortable: false,
    padding: 'normal',
    style: {
      width: '150px',
      paddingLeft: '16px'
    }
    // className: 'hide-mobile'
  },
  {
    id: 'journal_id',
    label: 'ws_journal.cell6',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'task_description',
    label: 'ws_journal.cell2',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px',
      width: '400px'
    }
    // className: 'hide-mobile'
  },
  {
    id: 'total_hours',
    label: 'ws_journal.cell7',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
    // className: 'hide-mobile'
  },
  {
    id: 'total_amount',
    label: 'ws_journal.cell5',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
    // className: 'hide-mobile'
  },
  {
    id: 'action',
    label: '',
    isSortable: false,
    padding: 'normal',
    style: {
      width: '150px',
      paddingLeft: '16px'
    }
    // className: 'hide-mobile'
  }
]

const journalRow = (el, index) => {
  return (
    <JournalRowContainer
      key={index}
      index={index}
      el={el}
      id={el.id}
      added_to_invoice={el.added_to_invoice}
      invoice_id={el.invoice_id}
      journal_id={el.journal_id}
      task_description={el.task_description}
      dateTimeRows={el.dateTimeRows}
      totalJournalAmount={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.totalJournalAmount)}
    />
  )
}

WorkshiftNormalUserComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(WorkshiftNormalUserComponent)
